/**
 * 完了画面のStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

export enum ActionTypes {
  INIT_COMPLETE = 'app/completion/INIT_COMPLETE'
}

/**
 * 初期化処理完了のActionを作成する
 * @param {boolean} payload 初期化処理実施状況
 */
export const initComplete = () => createAction(ActionTypes.INIT_COMPLETE);

const actions = {
  initComplete
};
type CompletionAction = ActionsUnion<typeof actions>;

/** 完了画面のState */
export interface CompletionState {
  /** 初期化処理実施状況 */
  initComplete: boolean;
}

const initialState: CompletionState = {
  initComplete: false
};

export default (
  state: CompletionState = initialState,
  action: CompletionAction
): CompletionState => {
  switch (action.type) {
    case ActionTypes.INIT_COMPLETE:
      return {
        ...state,
        initComplete: true
      };
    default:
      return state;
  }
};
